import { useQuery } from "@tanstack/react-query";
import { materialType } from "./query";
import { PostModel } from "common/models/BaseModel";
import { IMaterialTypeGridFilter } from "./types";

export function GetMaterialTypes(
  model: PostModel<IMaterialTypeGridFilter> | undefined
) {
  return useQuery(materialType.list(model));
}

export function GetMaterialType(Id: string | number | undefined) {
  return useQuery({
    ...materialType.getById(Id || ""),
    enabled: Boolean(Id),
  });
}

export function GetMaterialTypeValues() {
  return useQuery({
    ...materialType.getMaterialTypeValues(),
    refetchOnMount: true,
  });
}

export function GetMaterialTypeView(id: string | number | undefined, isOpen: boolean) {
  return useQuery({
    ...materialType.getViewById(id || ""),
    enabled: Boolean(id) && isOpen,
  });
}
